<nav #header *ngIf="renderMenu" class=" fixed-top headerStyle"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}"
    style="filter: drop-shadow(1px 1px 1px #6666664d);">
    <div style="background-color: black; border-bottom: 1px solid white;" class="contactHeader">
        <div class="container green containerHeader">
            <div class="contact-data">
                <a style="text-decoration: none; padding-right: 20px;" href="tel:+593979892032" target="_blank">
                    <i class="fa fa-phone" style="padding: 0 10px;"></i>
                    593 97 989 2032</a>
                <a href="mailto:sales&#64;galapagosdreamstours.com" target="_blank">
                    <i class="fa fa-envelope-o" style="padding: 0 10px;"></i>
                    sales&#64;galapagosdreamstours.com</a>
                <a target="_blank">
                    <i class="fa fa-map-marker" style="padding: 0 10px;"></i>
                    Cucuve 332 y Floreana / Puerto Ayora / Isla Santa Cruz</a>
            </div>
            <div style="display: flex; align-items: center; font-size: 1.1em;" class="desktop-rs">
                <a href="https://www.facebook.com/galapagosdreamsadventures/" target="_blank"><i
                        class="fa fa-facebook-square" style="padding: 0 12px;"></i></a>
                <a href="https://www.instagram.com/galapagosdreamstours/" target="_blank"><i class="fa fa-instagram"
                        style="padding: 0 12px;"></i></a>
                <a href="https://www.tripadvisor.es/Attraction_Review-g297533-d10825718-Reviews-Galapagos_Dreams_Adventures-Puerto_Ayora_Santa_Cruz_Galapagos_Islands.html"
                    target="_blank"><i class="fa fa-tripadvisor" style="padding: 0 12px;"></i></a>
                <a href="https://galapagosdreamstours.com/site"
                    style="border-left:1px solid white; border-right: 1px solid white; display: flex; height: 40px; align-items: center;"
                    target="_blank"><i class="fa fa-search" style="padding: 0 12px;"></i></a>
            </div>
            <div style="display: flex; align-items: center; font-size: 1.1em; justify-content: space-between; width: 100%;"
                class="mobile-rs">
                <div>
                    <a href="https://www.facebook.com/galapagosdreamsadventures/" target="_blank"><i
                            class="fa fa-facebook-square" style="padding: 0 12px;"></i></a>
                    <a href="https://www.instagram.com/galapagosdreamstours/" target="_blank"><i class="fa fa-instagram"
                            style="padding: 0 12px;"></i></a>
                    <a href="https://www.tripadvisor.es/Attraction_Review-g297533-d10825718-Reviews-Galapagos_Dreams_Adventures-Puerto_Ayora_Santa_Cruz_Galapagos_Islands.html"
                        target="_blank"><i class="fa fa-tripadvisor" style="padding: 0 12px;"></i></a>
                </div>
                <div>
                    <a href="https://galapagosdreamstours.com/site"
                        style="border-left:1px solid white; border-right: 1px solid white; display: flex; height: 40px; align-items: center;"
                        target="_blank"><i class="fa fa-search" style="padding: 0 12px;"></i></a>
                </div>
            </div>
        </div>
    </div>
    <div #header1 class="container green containerMenu">
        <div *ngIf="companyParamsService.getHasLogoInformation()" class="tooltip fade show bs-tooltip-right"
            role="tooltip" id="tooltip164687" x-placement="right"
            style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(266px, 24px, 0px);">
            <div class="arrow" style="top: 8px;"></div>
            <div class="tooltip-inner">Your Logo Here</div>
        </div>
        <a *ngIf="!this.companyParamsService.getWebSite()" class="navbar-brand" target="_blank" class="navbar-brand"
            data-container=".green" data-toggle="tooltip" data-placement="right" title="Your Logo Here">
            <img src="assets/img/logo.jpg" height="50" alt="logo" class="brand-logo">
        </a>
        <a *ngIf="this.companyParamsService.getWebSite()" href="https://galapagosdreamstours.com/site"
            class="navbar-brand" target="_blank">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().logoFade}}" id="logoFade">
            <input type="hidden" value="{{this.companyParamsService.getCompanyParams().fadeMenu}}" id="fadeMenu">
            <img src="../assets/images/logos-header/gd.svg" alt="logo" class="brand-logo" style="height: 75px;">
        </a>
        <div class="containerMenu navbar-collapse collapse" style="width: inherit;">
            <ul class="navbar-nav menuContainer" style="width: inherit;">
                <li class="nav-item menuItem"><a href="https://galapagosdreamstours.com/site/product-category/tours/"
                        target="_blank">TOURS</a></li>
                <li class="nav-item menuItem"><a
                        href="https://galapagosdreamstours.com/site/product-category/paquetes-galapagos/"
                        target="_blank">PAQUETES GALAPAGOS</a></li>
                <li class="nav-item menuItem"><a href="https://galapagosdreamstours.com/site/product-category/cruceros/"
                        target="_blank">CRUCEROS</a></li>
                <li class="nav-item menuItem"><a href="https://galapagosdreamstours.com/site/contacto/"
                        target="_blank">CONTACTO</a></li>
                <li class="nav-item menuItem cart-button"><a href="https://galapagosdreamstours.com/site/carrito/"
                        target="_blank">VER CARRITO</a>
                </li>
            </ul>
            <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                <app-heart-header></app-heart-header>
            </div>
        </div>
        <div class="container green containerHeader"
            style="justify-content: start; align-items: center; flex-direction: row!important;"
            class="responsiveHeader">
            <a class="menuButton" (click)="renderMenu()" href="javascript:void()"
                style="padding: 5px; color: white; background-color: rgb(0, 46, 141);">
                <i class="fa fa-bars fa-2x"></i>
            </a>
            <a class="cart-button" style="color: white; font-family: 'Open Sans', sans-serif; text-align: center;"
                href="https://galapagosdreamstours.com/site/carrito/" target="_blank">VER<br>CARRITO</a>
        </div>
    </div>
    <ul style="width: inherit; display: none;" class="menuContainer" [ngClass]="showMenu ? 'showMenu':''">
        <li class="nav-item menuItem"><a href="https://galapagosdreamstours.com/site/product-category/tours/"
                target="_blank">TOURS</a></li>
        <li class="nav-item menuItem"><a
                href="https://galapagosdreamstours.com/site/product-category/paquetes-galapagos/"
                target="_blank">PAQUETES GALAPAGOS</a></li>
        <li class="nav-item menuItem"><a href="https://galapagosdreamstours.com/site/product-category/cruceros/"
                target="_blank">CRUCEROS</a></li>
        <li class="nav-item menuItem"><a href="https://galapagosdreamstours.com/site/contacto/"
                target="_blank">CONTACTO</a></li>
    </ul>
    <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container"
        [ngClass]="showMenu ? 'showMenu':''" style="width: inherit; display: none;">
        <app-heart-header></app-heart-header>
    </div>
</nav>